var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9427 0.87868C15.5053 0.316071 16.2684 0 17.064 0H36.936C37.7316 0 38.4947 0.316071 39.0573 0.878679L53.1213 14.9427C53.6839 15.5053 54 16.2684 54 17.064V36.936C54 37.7316 53.6839 38.4947 53.1213 39.0573L39.0573 53.1213C38.4947 53.6839 37.7316 54 36.936 54H17.064C16.2684 54 15.5053 53.6839 14.9427 53.1213L0.878679 39.0573C0.316071 38.4947 0 37.7316 0 36.936V17.064C0 16.2684 0.316071 15.5053 0.87868 14.9427L14.9427 0.87868ZM18.3066 6L6 18.3066V35.6934L18.3066 48H35.6934L48 35.6934V18.3066L35.6934 6H18.3066ZM38.1213 15.8787C39.2929 17.0503 39.2929 18.9497 38.1213 20.1213L31.2426 27L38.1213 33.8787C39.2929 35.0503 39.2929 36.9497 38.1213 38.1213C36.9497 39.2929 35.0503 39.2929 33.8787 38.1213L27 31.2426L20.1213 38.1213C18.9497 39.2929 17.0503 39.2929 15.8787 38.1213C14.7071 36.9497 14.7071 35.0503 15.8787 33.8787L22.7574 27L15.8787 20.1213C14.7071 18.9497 14.7071 17.0503 15.8787 15.8787C17.0503 14.7071 18.9497 14.7071 20.1213 15.8787L27 22.7574L33.8787 15.8787C35.0503 14.7071 36.9497 14.7071 38.1213 15.8787Z",
    fill: "#B00020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.9982c09b.svg";
export { ForwardRef as ReactComponent };